import { forwardRef } from 'react'
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom'

export interface INavLinkWithQuery extends NavLinkProps {
  to: string
}

/**
 * NavLink with existing query string automatically appended
 *
 * `to` prop that contain search param will override any existing
 * URL search param of the same name.
 *
 * @param NavLinkProps
 * @returns see title
 */
const NavLinkWithQuery = forwardRef<HTMLAnchorElement, INavLinkWithQuery>(
  function NavLinkWithQueryRenderer({ children, to, ...props }, ref) {
    const { search } = useLocation()

    const searchParams = new URLSearchParams(search)
    const paths = to.split('?')
    let query = search

    if (paths.length > 1) {
      const newSearchParams = new URLSearchParams(paths[1])

      // Append or override search params
      newSearchParams.forEach((k, v) => {
        searchParams.set(k, v)
      })

      query = `?${searchParams.toString()}`
    }

    return (
      <NavLink ref={ref} to={paths[0] + query} {...props}>
        {children}
      </NavLink>
    )
  }
)

export default NavLinkWithQuery
